import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { find, orderBy, reduce, take } from 'lodash'
import { connect } from 'react-redux'
import DtoAnalysis from '../../dto/DtoAnalysis'
import DtoParameter from '../../../referential/dto/DtoParameter'
import { HorizontalBar, IChart } from 'react-aquasys'
import i18n from 'simple-react-i18n'

class MoleculeDetectedChartPanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			width: 0
		}
	}

	componentDidMount() {
		this.setState({ width: this.refs.mostMoleculeDetected.offsetWidth })
	}

	getParameterName = (filterId) => {
		if (this.props.parameters.length > 0 && filterId) {
			const result = find(this.props.parameters, (parameter) => {
				return parameter.id == filterId
			})
			if (result) {
				return result.name
			}
			return filterId
		}
		return filterId
	}
	getMostParametersDetected = () => {
		const nbParametes = reduce(this.props.analysis, (result, value) => {
			if (result[value.parameters]) {
				result[value.parameters] = result[value.parameters] + 1
			} else {
				result[value.parameters] = 1
			}
			return result
		}, {})
		const sortParameter = Object.keys(nbParametes).map((parameter) => {
			return {
				x: this.getParameterName(parameter),
				y: nbParametes[parameter]
			}
		})
		const data = take(orderBy(sortParameter, ['y'], ['desc']), 10).reverse()
		const serie = new HorizontalBar({ data: data, color: 'blue' })
		return (
			<IChart width={ this.state.width } height='450'
					series={ [serie] }/>
		)
	}

	render() {
		return (
			<div className='row no-margin'>
				<div className='col s6 m6 l12 no-margin no-padding'>
					<div className='row no-margin card-title hide-on-med-and-down no-margin'>
						{ i18n.mostDetectedMolecules }
					</div>
				</div>
				<div className='col s6 m6 l12 no-margin no-padding' ref='mostMoleculeDetected'>
					<div className='row no-margin'>
						{ this.getMostParametersDetected() }
					</div>
				</div>
			</div>
		)
	}
}


MoleculeDetectedChartPanel.propTypes = {
	analysis: PropTypes.arrayOf(PropTypes.objectOf(DtoAnalysis)),
	parameters: PropTypes.arrayOf(PropTypes.objectOf(DtoParameter))
}
MoleculeDetectedChartPanel.defaultProps = {
	analysis: [],
	parameters: []
}
const mapStateToProps = store => {
	return {
		analysis: store.DetailStationReducer.analysis,
		parameters: store.ReferentialReducer.parameters
	}
}

export default connect(mapStateToProps)(MoleculeDetectedChartPanel)



// WEBPACK FOOTER //
// ./src/station/components/qualitometer/MoleculeDetectedChartPanel.js